import { InfoCircleOutlined } from '@ant-design/icons'
import { Space, Tooltip, Typography } from 'antd'
import React from 'react'

const { Text } = Typography

export interface SectionTitleProps {
  title: string
  tooltip?: string
}

export default function SectionTitle({ title, tooltip }: SectionTitleProps) {
  return (
    <Space>
      <Text strong style={{ fontSize: 16 }}>{title}</Text>
      {tooltip &&
          <Tooltip title={tooltip}>
              <Text type="secondary">
                  <InfoCircleOutlined/>
              </Text>
          </Tooltip>
      }
    </Space>
  )
}